import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lead text-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "container-fluid p-0 custom-negative-margin",
    style: _normalizeStyle({
      backgroundImage: 'url(' + _ctx.backgroundUrl + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    })
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({ minHeight: _ctx.minHeight + 'vh' }),
      class: "d-flex flex-column flex-center"
    }, [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1),
      _createElementVNode("span", {
        class: "text-white fw-bold",
        style: _normalizeStyle({
          fontSize: _ctx.fontSize + 'rem',
        })
      }, _toDisplayString(_ctx.text), 5),
      _hoisted_2,
      _createElementVNode("span", {
        class: "fw-bolder",
        style: _normalizeStyle({
          fontSize: _ctx.subFontSize + 'rem',
          color: '#800000', /* Maroon color */
        })
      }, _toDisplayString(_ctx.subText), 5)
    ], 4)
  ], 4))
}